module.exports = __webpack_public_path__ + "static/media/Seeker_Sample_File.7ec5a343.csv";